import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap';
import CustomButton from './../../shared/CustomButton';
import { FaSignInAlt } from 'react-icons/fa';

const Login = ({
    isSaving, 
    formAction,
    onForgotPassword
}) => {
    const {
        register,
        handleSubmit,
        resetField,
        setError,
        formState: {errors}
    } = useForm();

    const onSubmit = async (data) => {
        try{
            const success = await formAction(data);
            if(!success){
                resetField('password');
            }
        } catch (error) {
            if (error.response && error.response.status === 422){
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // error to be handled by userLogin() in LoginScreen.jsx
            }
        }
    }
    
  return (
    <>

        <Form onSubmit={handleSubmit(onSubmit)}>

            <Form.Group>

                <Form.Label htmlFor='username'>Username</Form.Label>
                <input type='text' className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                    autoFocus autoComplete='off' placeholder='Username'
                    {...register('username', {
                        required: 'Enter your username',
                        pattern: {
                            value: /^[a-zA-Z0-9]{8,16}$/,
                            message: 'Username must be alphanumeric with between 8 and 16 characters'
                        }
                    })}
                />
                {errors.username && (
                    <div className="invalid-feedback">{errors.username.message}</div>
                )}

            </Form.Group>

            <Form.Group>

                <Form.Label htmlFor='password'>Password</Form.Label>
                <input type='password' className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                    {...register('password', {
                        required: 'Enter your password'
                    })}
                />
                {errors.password && (
                    <div className="invalid-feedback">{errors.password.message}</div>
                )}

            </Form.Group>

            <CustomButton
                icon={<FaSignInAlt />}
                title={isSaving ? 'Logging In...' : 'Login'}
                isSaving={isSaving}
            />

        </Form>

        <div className="text-center">

            <a href='#' className='auth-link' onClick={(e) => {e.preventDefault(); onForgotPassword()}}>Forgot Password?</a>
        </div>
    </>
  )
}

export default Login